import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { user, login, checking } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (checking) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Impossible de se connecter.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pt-[160px] pb-40 max-w-[500px] mx-auto px-6" data-testid="admin-login-page">
      <p className="label mb-6" style={{ color: "#C9A961" }}>Espace privé</p>
      <h1 className="font-serif" style={{ fontSize: 64, lineHeight: 1, color: "#F8F6F0" }}>
        Connexion
      </h1>
      <p className="mt-6" style={{ color: "rgba(248,246,240,0.7)", fontSize: 15, lineHeight: 1.7 }}>
        Espace réservé à la rédaction et aux administrateurs de Le Stand d'Or.
      </p>

      <form onSubmit={onSubmit} className="mt-14 space-y-10" data-testid="admin-login-form">
        <div>
          <label htmlFor="admin-email" className="label block mb-3">Adresse email</label>
          <input
            id="admin-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-editorial"
            placeholder="admin@lestanddor.com"
            data-testid="admin-email-input"
          />
        </div>
        <div>
          <label htmlFor="admin-password" className="label block mb-3">Mot de passe</label>
          <input
            id="admin-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-editorial"
            placeholder="••••••••"
            data-testid="admin-password-input"
          />
        </div>
        {error && (
          <p className="label" style={{ color: "#C9A961" }} data-testid="admin-login-error">
            {error}
          </p>
        )}
        <button type="submit" className="btn-solid" disabled={submitting} data-testid="admin-login-submit">
          {submitting ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
